/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "detection";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface DetectionClass {
}

export enum DetectionClass_Enum {
  PERSON = 0,
  CAR = 1,
  FIDUCIAL = 2,
  STANFORD_PIGEON = 3,
  CASE = 4,
  DOCK = 5,
  CONTAINER = 6,
  TTID_TOWER = 7,
  TTID_INSULATOR = 8,
  G47 = 9,
  UNRECOGNIZED = -1,
}

export function detectionClass_EnumFromJSON(object: any): DetectionClass_Enum {
  switch (object) {
    case 0:
    case "PERSON":
      return DetectionClass_Enum.PERSON;
    case 1:
    case "CAR":
      return DetectionClass_Enum.CAR;
    case 2:
    case "FIDUCIAL":
      return DetectionClass_Enum.FIDUCIAL;
    case 3:
    case "STANFORD_PIGEON":
      return DetectionClass_Enum.STANFORD_PIGEON;
    case 4:
    case "CASE":
      return DetectionClass_Enum.CASE;
    case 5:
    case "DOCK":
      return DetectionClass_Enum.DOCK;
    case 6:
    case "CONTAINER":
      return DetectionClass_Enum.CONTAINER;
    case 7:
    case "TTID_TOWER":
      return DetectionClass_Enum.TTID_TOWER;
    case 8:
    case "TTID_INSULATOR":
      return DetectionClass_Enum.TTID_INSULATOR;
    case 9:
    case "G47":
      return DetectionClass_Enum.G47;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DetectionClass_Enum.UNRECOGNIZED;
  }
}

export function detectionClass_EnumToJSON(object: DetectionClass_Enum): string {
  switch (object) {
    case DetectionClass_Enum.PERSON:
      return "PERSON";
    case DetectionClass_Enum.CAR:
      return "CAR";
    case DetectionClass_Enum.FIDUCIAL:
      return "FIDUCIAL";
    case DetectionClass_Enum.STANFORD_PIGEON:
      return "STANFORD_PIGEON";
    case DetectionClass_Enum.CASE:
      return "CASE";
    case DetectionClass_Enum.DOCK:
      return "DOCK";
    case DetectionClass_Enum.CONTAINER:
      return "CONTAINER";
    case DetectionClass_Enum.TTID_TOWER:
      return "TTID_TOWER";
    case DetectionClass_Enum.TTID_INSULATOR:
      return "TTID_INSULATOR";
    case DetectionClass_Enum.G47:
      return "G47";
    case DetectionClass_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseDetectionClass(): DetectionClass {
  return {};
}

export const DetectionClass = {
  encode(_: DetectionClass, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DetectionClass {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetectionClass();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DetectionClass {
    return {};
  },

  toJSON(_: DetectionClass): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DetectionClass>, I>>(base?: I): DetectionClass {
    return DetectionClass.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DetectionClass>, I>>(_: I): DetectionClass {
    const message = createBaseDetectionClass();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
